import React, { FC, useEffect, useState } from 'react';
import { Button, Select, Space, Tag, Tooltip } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { PerformanceCycle } from '../../entity/PerformanceCycle';
import Title from 'antd/lib/typography/Title';

const getCycleTagColor = (cycle: PerformanceCycle) => {
  if (cycle.closestCycle) {
    return '#52c41a';
  }

  if (cycle.status === 'Active') {
    return '#1677ff';
  }

  if (cycle.status === 'Non Active' || cycle.status === 'Completed') {
    return '#8c8c8c';
  }

  return '#8c8c8c';
};

type ItemToggleProps = {
  data: any[];
  max: number;
  setCurrentValue: (value: number) => void; //Dispatch<SetStateAction<number>>;
  initValue?: number;
};

const ItemToggle: FC<ItemToggleProps> = (props) => {
  const [iValue, setIValue] = useState<number>(0);
  useEffect(() => {
    setIValue(props.initValue ? props.data.findIndex((e) => props.initValue === e.id) : 0);
  }, [props.data, props.initValue]);
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
      }}>
      <Button
        shape="circle"
        style={{ marginRight: 20 }}
        icon={<LeftOutlined />}
        onClick={() => {
          props.setCurrentValue(props.data[iValue !== 0 ? iValue - 1 : props.max - 1].id);
          setIValue(iValue !== 0 ? iValue - 1 : props.max - 1);
        }}
      />
      {`${props.data[iValue]?.name} ( ${props.data[iValue]?.startDate} - ${props.data[iValue]?.endDate} )`}
      <Button
        shape="circle"
        style={{ marginLeft: 20 }}
        icon={<RightOutlined />}
        onClick={() => {
          props.setCurrentValue(props.data[iValue < props.max - 1 ? iValue + 1 : 0].id);
          setIValue(iValue < props.max - 1 ? iValue + 1 : 0);
        }}
      />
    </div>
  );
};

type CycleToggleProps = {
  data: PerformanceCycle[];
  value?: number;
  onChange?: (value?: number) => void;
  disable?: boolean;
};

export const CycleToggle: FC<CycleToggleProps> = (props) => {
  return (
    <>
      {props.data.length !== 0 && (
        <Space style={{ paddingBottom: 10 }} size={0}>
          <Tooltip title="Go to previous cycle">
            <Button
              // type="primary"
              disabled={props?.disable ?? false}
              shape="circle"
              onClick={() => {
                if (props.value && props.data.findIndex((e) => props.value == e.id) > 0) {
                  props.onChange?.(
                    props.data[props.data.findIndex((e) => props.value == e.id) + -1].id,
                  );
                }
              }}>
              <LeftOutlined />
            </Button>
          </Tooltip>
          <Select
            disabled={props?.disable ?? false}
            bordered={false}
            showArrow={false}
            dropdownMatchSelectWidth={false}
            value={props.value}
            onChange={props.onChange}
            style={{ width: 'auto' }}>
            {props.data.map((value) => (
              <Select.Option key={value.id!} value={value.id!}>
                <>
                  <Tooltip
                    title={`(${value.startDate?.replace(/-/g, '/')} - ${value.endDate?.replace(
                      /-/g,
                      '/',
                    )})`}>
                    <Tag color={getCycleTagColor(value)} style={{ borderRadius: 15, margin: 0 }}>
                      <Title level={5} style={{ color: 'white', margin: 0 }}>
                        {value.name}
                      </Title>
                    </Tag>
                  </Tooltip>
                </>
              </Select.Option>
            ))}
          </Select>
          <Tooltip title="Go to next Cycle">
            <Button
              // type="primary"
              disabled={props?.disable ?? false}
              shape="circle"
              onClick={() => {
                if (
                  props.value &&
                  props.data.findIndex((e) => props.value == e.id) < props.data.length - 1
                ) {
                  props.onChange?.(
                    props.data[props.data.findIndex((e) => props.value == e.id) + 1].id,
                  );
                }
              }}>
              <RightOutlined />
            </Button>
          </Tooltip>
        </Space>
      )}
    </>
  );
};

export default ItemToggle;
